import plural from "./Plural";

export default class ZoiDate {

    constructor(date, timezoneOffset) {
        this.date = new Date(date);
        this.now = new Date();

        if (timezoneOffset) {
            this.date.setTime(this.date.getTime() - timezoneOffset * 60000);
            this.now.setTime(this.now.getTime() - timezoneOffset * 60000);
        }
    }

    static from(date, timezoneOffset) {
        return new this(date, timezoneOffset)
    }

    get diff() {
        const dateDifferenceInSeconds = (dateInitial, dateFinal) => (dateFinal - dateInitial) / 1_000;

        return dateDifferenceInSeconds(this.date, this.now);
    }

    isFuture() {
        return this.diff < 0;
    }

    get relative() {
        let itemDate = this.date;
        let secondsPassed = this.diff;
        let today = this.now.getDate();
        let thisMonth = this.now.getMonth();
        let thisYear = this.now.getFullYear();

        let dateDay = itemDate.getDate();
        let dateMonth = itemDate.getMonth();
        let dateYear = itemDate.getFullYear();

        if (secondsPassed < 60) {
            return 'только что';
        }

        if (secondsPassed < 3600) {
            return Math.floor(secondsPassed / 60) + ' мин';
        }

        if (dateDay === today && thisMonth === dateMonth && dateYear === thisYear) {
            let hours = Math.floor(secondsPassed / 3600);

            return plural(hours, ['час', 'часа', 'часов']);
        }

        if (thisYear === dateYear) {
            return itemDate.getDate() + ' ' + this.shortMonths[dateMonth];
        }

        return dateDay + ' ' + this.shortMonths[dateMonth] + ' ' + dateYear.toString().substring(2, 4)
    }

    get full() {
        return this.date.getDate() + ' '
            + this.getShortMonthName(this.date) + ' '
            + this.date.getFullYear() + ', '
            + this.getHours(this.date) + ':'
            + this.getMinutes(this.date);
    }

    get toDate() {
        return this.date;
    }

    getShortMonthName(date) {
        return this.shortMonths[date.getMonth()]
    }

    getHours(date) {
        return date.getHours().toString().padStart(2, '0');
    }

    getMinutes(date) {
        return date.getMinutes().toString().padStart(2, '0');
    }

    get shortMonths() {
        return {
            0: "янв",
            1: "фев",
            2: "мар",
            3: "апр",
            4: "мая",
            5: "июн",
            6: "июл",
            7: "авг",
            8: "сен",
            9: "окт",
            10: "ноя",
            11: "дек",
        }
    }
}
